<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mPjIJS/tc-custom/9781466800762.jpg?1737767350661" alt="This image is the cover for the book Burning Paradise"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Burning Paradise
      </h1>
      <p class="bookDescription body article font2">
        <b>In an alternate world, peace comes at a terrifying cost—as aliens kill to maintain their secret—in this novel by the Hugo Award–winning author of <i>Spin</i>.</b><br/><br/>Cassie Klyne, nineteen years old, lives in the United States in the year 2015—but it’s not our United States, and it’s not our 2015. Cassie’s world has been at peace since the Great Armistice of 1918. There was no World War II, no Great Depression. Poverty is declining, prosperity is increasing everywhere; social instability is rare. But Cassie knows the world isn’t what it seems.<br/><br/>Her parents were part of a group who gradually discovered the awful truth: that for decades—back to the dawn of radio communications—human progress has been molded, made more peaceful and benign, by an extraterrestrial entity. That by interfering with our communications, this entity has tweaked history in massive and subtle ways. That humanity is, for purposes unknown, being farmed.<br/><br/>Cassie’s parents were killed for this knowledge, along with most of the other members of their group. Since then, the survivors have scattered and gone into hiding. Cassie and her younger brother Thomas now live with her aunt Nerissa, who shares these dangerous secrets. Others live nearby. For eight years they have attempted to lead unexceptional lives in order to escape detection. The tactic has worked.<br/><br/>Until now. Because the killers are back. And they’re not human.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert Charles Wilson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      A Tom Doherty Associates Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?42daf016